import React from 'react';
import { SimpleGrid, Heading, VStack, Body } from '@hover/blueprint';
import { PARTNER_BEACON_ORDER_PAGE_ADVANTAGES } from '../../../constants';

const MIN_ITEM_WIDTH = 400;

const Advantages = () => (
  <SimpleGrid
    minChildWidth={MIN_ITEM_WIDTH}
    gap={10}
    w="100%"
    justifyItems="center"
    maxW="7xl"
    m="auto"
  >
    {PARTNER_BEACON_ORDER_PAGE_ADVANTAGES.map(a => (
      <VStack
        bgColor="white"
        borderRadius={14}
        minW={MIN_ITEM_WIDTH}
        py={900}
        px={800}
        key={a.heading}
        textAlign="center"
        justifyContent="center"
      >
        <Heading>{a.heading}</Heading>
        <Body>{a.body}</Body>
      </VStack>
    ))}
  </SimpleGrid>
);

export default Advantages;
